// extracted by mini-css-extract-plugin
export var reveal = "reveal-module--reveal--g+PNB";
export var fade = "reveal-module--fade--LN9eq";
export var zoom = "reveal-module--zoom--AtS41";
export var flip = "reveal-module--flip--fUzT+";